export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7110.76d1a569.jpg";